import { Box, Typography } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '@repo/ui/StructuredContentRenderer';
import { ConsIcon } from './ConsIcon';

export const ConsItems = ({ con }: { con?: StructuredContentDocument | string }) => {
  return (
    <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
      <ConsIcon />
      {typeof con === 'string' ? (
        <Typography>{con}</Typography>
      ) : (
        <StructuredContentRenderer doc={con} />
      )}
    </Box>
  );
};
